/// <reference path="../../winrtrefs.d.ts" />
// @ts-nocheck
export default class Store {
    storeContext; // : Windows.Services.Store.StoreContext;

    constructor() {
        this.storeContext = Windows.Services.Store.StoreContext.getDefault();
    }

    getAddonInfo = async (iapIds /*: string[]*/) => {
        let addonInfo = [];
        try {
            const result = await this.storeContext.getStoreProductsAsync(
                ['Durable'],
                iapIds
            );
            if (result && result.products && result.products.size > 0) {
                iapIds.forEach(element => {
                    if (result.products.hasKey(element)) {
                        // console.log(result.products[element]);
                        addonInfo.push({
                            storeId: result.products[element].storeId,
                            title: result.products[element].title,
                            formattedPrice: result.products[element].price.formattedPrice
                        });
                    }
                });
                return addonInfo;
            }
        }
        catch {
            return addonInfo;
        }
    }

    purchaseAddon = async (addonId) => {
        try {
            let result = await this.storeContext.requestPurchaseAsync(addonId);
            if (result.status === Windows.Services.Store.StorePurchaseStatus.succeeded 
                || result.status === Windows.Services.Store.StorePurchaseStatus.alreadyPurchased) {
                return true;
            }
            else {
                return false;
            }
        }
        catch {
            return false;
        }
    }

    areAnyAddonsPurchased = async () => {
        try {
            let result = await this.storeContext.getAppLicenseAsync();
            if (result.addOnLicenses && result.addOnLicenses.size > 0) {
                return true;
            } else {
                return false;
            }
        }
        catch {
            return false;
        }
    }


    // private arrayToIIterable = (strings: string[]) => {
    //     const map = new Windows.Foundation.Collections.StringMap();
    //     for (const str of strings) {
    //         map.insert(str, str);
    //     }
    //     return map;
    // }
}
